import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import Carousel from 'react-slick';

/**
 * Wrapup tour slides.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Tour extends Component {
  constructor(props) {
    super(props);

    this.state = { atIntro: true };

    this.start = this.start.bind(this)
    this.next = this.next.bind(this);
    this.renderStep = this.renderStep.bind(this);
  }

  start() {
    this.setState({ atIntro: false });
  }

  next() {
    this.refs.tour_carousel.slickNext()
  }

  renderStep(step, i) {
    const { onDone, steps } = this.props
    const isLast = i == steps.length - 1;

    return (
      <div key={i}>
        <div className={classnames("slide", { last: isLast, "has-button": !isLast || onDone })}>
          <div className="row">
            <div className="small-16 medium-8 columns">
              { step.header && <h5>{ step.header }</h5> }
              <h2>{ step.title }</h2>
              <p>{ step.description }</p>

              { !isLast &&
              <button className="btn btn-tertiary hide-for-small-only" onClick={this.next}>
                Next
              </button> }

              { isLast && onDone &&
              <button className="btn btn-tertiary" onClick={onDone}>
                Start Wrap-up
              </button> }
            </div>
            <div className="small-16 medium-6 medium-offset-2 columns">
              <img src={step.image} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { onDone, steps, intro } = this.props

    const settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      arrows: false
    }

    return (
      <div className="row">
        <div className="small-16 columns">
          <div className="project-tour wrapup-tour">
            { this.state.atIntro?
            <div className="slide intro">
              <h2>{ intro.title }</h2>
              <p>{ intro.description }</p>

              <button className="btn btn-tertiary" onClick={this.start}>
                Start wrap-up tour
              </button>

              { onDone &&
              <button className="btn btn-text btn-md" onClick={onDone}>
                Skip the tour
              </button> }
            </div> :
            <Carousel {...settings} ref="tour_carousel">
              { steps.map(this.renderStep) }
            </Carousel> }
          </div>
        </div>
      </div>
    )
  }
}

Tour.propTypes = {
  intro: PropTypes.object.isRequired,
  steps: PropTypes.array.isRequired,
  onDone: PropTypes.func,
};



// WEBPACK FOOTER //
// ./project/components/wrapup/tour.jsx